import { FC } from 'react';
import { Box } from '../../components';

export const InlineCode: FC<{}> = props => {
  return (
    <Box
      fontFamily="mono"
      as="code"
      bg="neutral.1"
      fontSize="90%"
      p="1px 2px"
      borderRadius="3px"
      {...props}
    />
  );
};
